const iifDocumentState = (cb) => (document) => {
    if (document && document.document_state) return cb(document.document_state, document);

    console.warn(`Document ${document ? document.id : document} does not have a document_state`);

    return false;
}

/**
 * Verifica se o documento está "Desvinculado".
 * @return boolean
 */
export const isUnlinkedDocument = iifDocumentState((state) => state.enum === 'unlinked');

/**
 * Verifica se o documento é do DocGo.
 * @return boolean
 */
export const isDocGoDocument = iifDocumentState((state) => state.state === 'DocGo' || state.name === 'DocGo');



// WEBPACK FOOTER //
// ./src/mixins/document-check.js